import { getCompatConfig } from '../compat.js';

const getCompatSentry = () => {
  return getCompatConfig().SENTRY;
};
const captureException = (...args) => getCompatSentry().captureException(...args);
const captureMessage = (...args) => getCompatSentry().captureMessage(...args);
const captureUnderscoreErrorException = (...args) => getCompatSentry().captureUnderscoreErrorException(...args);
const withScope = (scopeOrCallback, callback) => {
  if (callback) {
    return getCompatSentry().withScope(scopeOrCallback, callback);
  }
  if (typeof scopeOrCallback === "function") {
    return getCompatSentry().withScope(void 0, scopeOrCallback);
  }
  throw new Error("Invalid arguments passed to withScope");
};
const setTag = (...args) => {
  getCompatSentry().setTag(...args);
};
const reactRouterV4BrowserTracingIntegration = (...args) => getCompatSentry().reactRouterV4BrowserTracingIntegration(...args);

export { captureException, captureMessage, captureUnderscoreErrorException, getCompatSentry, reactRouterV4BrowserTracingIntegration, setTag, withScope };
//# sourceMappingURL=sentry.js.map
